var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeShapesSmallScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spikeShapes"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,220 316,240 0,260"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,354 0,380 375,375 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,494 51,526 375,525 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,802 250,833 0,830"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,926 62,970 375,965"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,1234 195,1259 375,1255"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,1334 300,1347 0,1295"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,1544 199,1570 0,1576"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,1700 38,1710 375,1730"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,1963 117,2016 375,2003"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,2306 58,2331 375,2342"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,2410 300,2451 0,2450"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,2788 58,2811 375,2820"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,3200 316,3220 0,3250"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,3500 51,3530 375,3540 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,4044 350,4070 0,4080"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375,4534 10,4540 375,4555"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,5034 330,5045 0,5060"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeShapesSmallScreen);
export default __webpack_public_path__ + "static/media/SpikeShapesSmallScreen.2d4b997255943806e34109c0b8aec4c3.svg";
export { ForwardRef as ReactComponent };